<template>
  <span>
    <v-data-iterator
      :items="employees"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      loading
      loading-text="loading employees...please wait..."
      no-data-text="no records"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar class="mb-2" color="indigo darken-5" dark flat>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
          ></v-text-field>
          <v-btn
            v-if="permissions.rights != 'read_only'"
            fab
            dark
            color="blue darken-3"
            class="ml-1"
            @click="openDialog"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="emp in props.items"
            :key="emp.id"
            cols="12"
            sm="6"
            md="4"
            lg="4"
          >
            <v-card>
              <v-card-title class="subheading font-weight-bold">
                <v-list-item-avatar
                  ><img :src="showImage(emp.image)"
                /></v-list-item-avatar>
                <span style="cursor: pointer;" @click="showDetailView(emp)">
                  {{ emp.firstname }} {{ emp.lastname }}</span
                >
                <v-spacer></v-spacer>
                <v-icon
                  v-if="permissions.rights != 'read_only'"
                  small
                  class="mdi mdi-border-color"
                  @click="editItem(emp)"
                ></v-icon>
              </v-card-title>

              <v-divider></v-divider>

              <v-list dense>
                <v-list-item>
                  <v-list-item-content>Department:</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ emp.dept_name }}
                    <span v-if="emp.unit_name">/ {{ emp.unit_name }}</span>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Staff no.:</v-list-item-content>
                  <v-list-item-content class="align-end">{{
                    emp.employee_no
                  }}</v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Insurance no.:</v-list-item-content>
                  <v-list-item-content class="align-end">{{
                    emp.insurance_no
                  }}</v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Status:</v-list-item-content>
                  <v-list-item-content class="align-end"
                    ><!-- -->
                    <v-chip
                      v-if="emp.service_status === 1"
                      class="mx-auto"
                      color="primary"
                    >
                      Active</v-chip
                    >
                    <v-chip
                      v-if="emp.service_status === 0"
                      class="mx-auto"
                      color="red"
                    >
                      Inactive</v-chip
                    > </v-list-item-content
                  ><!-- -->
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Retirement Date.:</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ getDateOfRetirement(emp.dob) | formatShortDate }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <!-- <span class="grey--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn dark text color="primary" class="ml-2" v-on="on">
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->

          <v-spacer></v-spacer>

          <span
            class="mr-4
            grey--text"
          >
            Page {{ page }} of {{ numberOfPages }}
          </span>

          <v-icon @click="formerPage" class="mdi-chevron-double-right"
            >mdi-chevron-left</v-icon
          >
          <v-icon @click="nextPage" class="mdi-chevron-double-right"
            >mdi-chevron-right</v-icon
          >
        </v-row>
      </template>
    </v-data-iterator>
    <v-dialog v-model="dialog" max-width="700px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-for="header in headers"
                  :key="header.value"
                >
                  <v-text-field
                    v-if="
                      header.value != 'action' &&
                        header.type != 'select_dept' &&
                        header.type != 'select_title' &&
                        header.type != 'select_gender' &&
                        header.type != 'select_ss' &&
                        header.type != 'dob' &&
                        header.type != 'date_emp' &&
                        header.type != 'select_iss_date' &&
                        header.type != 'select_unit'
                    "
                    v-model="editedItem[header.value]"
                    :label="header.text"
                    required
                    :rules="[v => !!v || 'Item is required']"
                  ></v-text-field>
                  <v-autocomplete
                    v-if="header.type === 'select_dept'"
                    :items="departments"
                    v-model="editedItem[header.id]"
                    item-text="dept_name"
                    item-value="dept_id"
                    v-on:change="updateUnit(editedItem[header.id])"
                    :label="header.text"
                    auto-select-first
                    required
                    :rules="[v => !!v || 'Item is required']"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-if="header.type === 'select_unit'"
                    :items="department_units"
                    v-model="editedItem[header.id]"
                    item-text="unit_name"
                    item-value="unit_id"
                    :label="header.text"
                    auto-select-first
                  ></v-autocomplete>
                  <v-select
                    v-if="header.type === 'select_title'"
                    :items="titles"
                    v-model="editedItem[header.value]"
                    item-text="title"
                    item-value="title"
                    auto-select-first
                    :label="header.text"
                    required
                    :rules="[v => !!v || 'Item is required']"
                  ></v-select>
                  <v-select
                    v-if="header.type === 'select_gender'"
                    :items="genders"
                    v-model="editedItem[header.value]"
                    item-text="gender"
                    item-value="gender"
                    auto-select-first
                    :label="header.text"
                    required
                    :rules="[v => !!v || 'Item is required']"
                  ></v-select>
                  <v-select
                    v-if="header.type === 'select_ss'"
                    :items="service_status"
                    v-model="editedItem[header.value]"
                    item-text="service_name"
                    item-value="service_id"
                    auto-select-first
                    :label="header.text"
                    required
                  ></v-select>
                  <v-menu
                    v-model="menu"
                    v-if="header.type === 'dob'"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dob"
                        v-if="header.type === 'dob'"
                        :label="header.text"
                        prepend-icon="mdi mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dob"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>

                  <v-menu
                    v-model="menu1"
                    v-if="header.type === 'date_emp'"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date_emp"
                        v-if="header.type === 'date_emp'"
                        :label="header.text"
                        prepend-icon="mdi mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date_emp"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>

                  <v-menu
                    v-model="menu2"
                    v-if="header.type === 'select_iss_date'"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="in_iss_date"
                        v-if="header.type === 'select_iss_date'"
                        :label="header.text"
                        prepend-icon="mdi mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="in_iss_date"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <img :src="imageUrl" height="150" v-if="imageUrl" />
                <v-file-input
                  accept=".png, .jpg, .jpeg"
                  chips
                  ref="image"
                  v-model="image"
                  @change="onImagePicked"
                  show-size
                  counter
                  label="Photo"
                  v-if="editedIndex != -1"
                ></v-file-input>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialogDetailView" max-width="900px">
      <v-card>
        <v-card-title>
          <span>Employee Details</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <detail-view-card
            v-bind:props_data="selected_employee"
            v-bind:props_retirement_date="retirement_date"
            v-bind:props_image="selected_image_name"
            v-bind:props_dependents="dependent_list"
          ></detail-view-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogDetailView = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-container grid-list-lg>
      <v-layout row> </v-layout>
      <v-layout row wrap class="">
        <v-flex v-for="emp in employees" :key="emp.id" xs12 sm12 md4>
          <v-card>
            <v-responsive>
              <v-img
                src="http://source.unsplash.com/hjCA3ecCXAQ"
                height="300px"
              >
                <!--<v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline white--text">{{ emp.name }}</span>
                  </v-flex>
                </v-layout>
              </v-container> 
              </v-img>
            </v-responsive>

            <v-card-text>
              <div>
                <h3 class="headline mb-0">{{ emp.name }}</h3>
                <div>{{ emp.dept }}</div>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-btn outlined block color="green" @click="show(emp.id)">
                View</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container> -->
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ImageService from "@/services/image.service";
import Authorisation from "@/services/authorisation.service";
import {
  FETCH_EMPLOYEES,
  FETCH_UNITS,
  FETCH_UNITS_DEPARTMENT,
  EMPLOYEE_ADD,
  EMPLOYEE_EDIT,
  FETCH_DEPENDENTS_BY_EMPLOYEE
} from "@/store/modules/actions.type";

import DetailViewCard from "@/components/DetailViewCard";

export default {
  name: "EmployeeList",
  components: {
    DetailViewCard
  },
  data: () => ({
    valid: true,
    dialog: false,
    dialogDetailView: false,
    image: null,
    imagePublicUrl: null,
    base64img: null,
    imageUrl: null,
    imgUrl: null,
    imageFile: null,
    selected_image_name: null,
    menu: null,
    menu1: null,
    menu2: null,
    itemsPerPage: 15,
    itemsPerPageArray: [4, 8, 12],
    search: "",
    filter: {},
    page: 1,
    page_number: null,
    slug: "slug",
    loading: null,
    errored: null,
    errors: {},
    selected_employee: null,
    retirement_date: null,
    permissions: [],
    employees: [],
    departments: [],
    dependent_list: null,
    selected_dept: null,
    department_units: [],
    editedIndex: -1,
    dob: new Date().toISOString().substr(0, 10),
    date_emp: new Date().toISOString().substr(0, 10),
    in_iss_date: new Date().toISOString().substr(0, 10),
    titles: ["Mr", "Mrs", "Miss", "Dr", "Prof."],
    genders: ["Male", "Female"],
    service_status: [
      { sid: 2, service_id: 0, service_name: "In Active" },
      { sid: 3, service_id: 1, service_name: "Active" }
    ],
    headers: [
      { text: "Title", value: "title", type: "select_title" },
      { text: "Gender", value: "gender", type: "select_gender" },
      {
        text: "Department",
        value: "dept_name",
        id: "dept_id",
        type: "select_dept"
      },
      {
        text: "Unit",
        value: "unit_name",
        id: "unit_id",
        type: "select_unit"
      },
      { text: "First name", value: "firstname" },
      { text: "Last name", value: "lastname" },
      { text: "Employee no", value: "employee_no" },
      { text: "Employment Date", value: "dateofemployement", type: "date_emp" },
      { text: "Date of Birth", value: "dob", type: "dob" },
      { text: "Insurance no", value: "insurance_no" },
      {
        text: "Insurance Issued Date",
        value: "insurance_iss_date",
        type: "select_iss_date"
      },
      { text: "Service Status", value: "service_status", type: "select_ss" }
    ],
    editedItem: {
      title: "",
      gender: "",
      firstname: "",
      lastname: "",
      middlename: "",
      dept_id: "",
      unit_id: "",
      employee_no: "",
      dob: "",
      dateofemployement: "",
      insurance_no: "",
      insurance_iss_date: "",
      service_status: ""
    },
    defaultItem: {
      title: "",
      gender: "",
      firstname: "",
      lastname: "",
      middlename: "",
      dept_id: "",
      unit_id: "",
      employee_no: "",
      dob: "",
      dateofemployement: "",
      insurance_no: "",
      insurance_iss_date: "",
      service_status: ""
    }
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Staff" : "Edit Staff";
    },
    numberOfPages() {
      return Math.ceil(this.employees.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter(key => key !== `Name`);
    }
  },
  watch: {
    dialog(val) {
      val || this.close();

      if (val)
        this.$store.dispatch("department/fetchDepartments").then(res => {
          this.departments = res;
        });
      this.$store.dispatch(FETCH_UNITS, val).then(res => {
        this.department_units = res.units;
      });
    },
    selected_dept(val) {
      // console.log(val)
      this.$store.dispatch(FETCH_UNITS_DEPARTMENT, val).then(res => {
        this.department_units = res.units;
      });
    }
  },
  mounted() {
    this.imagePublicUrl = ImageService.getPublicImageUrl();
    this.fetchEmployees();
    // this.permissions = Authorisation.getRights();
    this.permissions = Authorisation.getAccessPermission();
    //console.log(Authorisation.getAccessPermission());
    //console.log(this.imagePublicUrl);
  },
  methods: {
    fetchEmployees(page = 1) {
      let slug = page;
      this.$store.dispatch(FETCH_EMPLOYEES).then(res => {
        //, { slug }
        //console.log(res.employees);
        this.employees = res.employees;
      });
    },
    getDependents(_id) {
      const emp_id = _id;

      this.$store.dispatch(FETCH_DEPENDENTS_BY_EMPLOYEE, emp_id).then(res => {
        //console.log(res.dependents);
        this.dependent_list = res.dependents;
      });
    },
    showImage(name) {
      //return ImageService.getImage(name);
      return this.imagePublicUrl + name;
    },
    updateUnit(dept_id) {
      if (dept_id) this.selected_dept = dept_id;
    },
    getDateOfRetirement(dob) {
      let newFormat = moment(dob).format("DD-MM-YYYY");
      return newFormat
        ? moment(newFormat, "DD-MM-YYYY").add(60, "years")
        : "Date not set!";
    },
    openDialog() {
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = this.employees.indexOf(item);
      this.editedItem = Object.assign({}, item);

      if (this.editedItem.dob) {
        this.dob = moment(this.editedItem.dob).format("YYYY-MM-DD");
      } else {
        this.dob = new Date().toISOString().substr(0, 10);
      }

      if (this.editedItem.dateofemployement) {
        this.date_emp = moment(this.editedItem.dateofemployement).format(
          "YYYY-MM-DD"
        );
      } else {
        this.date_emp = new Date().toISOString().substr(0, 10);
      }

      if (this.editedItem.insurance_iss_date) {
        this.in_iss_date = moment(this.editedItem.insurance_iss_date).format(
          "YYYY-MM-DD"
        );
      } else {
        this.in_iss_date = new Date().toISOString().substr(0, 10);
      }
      //console.log(item)
      this.dialog = true;
    },
    showDetailView(item) {
      this.dialogDetailView = true;
      if (item) this.selected_employee = item;
      this.retirement_date = this.getDateOfRetirement(item.dob);
      this.selected_image_name = this.showImage(item.image);
      this.getDependents(item.id);
      // console.log(this.selected_employee);
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    submit(slug, data) {
      //console.log(data);
      if (slug === "add") {
        this.$store
          .dispatch(EMPLOYEE_ADD, { slug, data })
          .then(() => {
            this.$noty.success("Data saved!");
            this.fetchEmployees();
          })
          .catch(({ response }) => {
            this.errors = response.data;
          });
      } else {
        this.$store
          .dispatch(EMPLOYEE_EDIT, { slug, data })
          .then(() => {
            this.$noty.success("Data updated!");
            this.fetchEmployees();
          })
          .catch(({ response }) => {
            this.errors = response.data;
          });
      }
    },
    onImagePicked(e) {
      const file = e;
      if (file != undefined || file != null) {
        this.imageName = file.name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.base64img = fr.result;
          this.imageFile = file; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    save() {
      if (!this.$refs.form.validate()) return;
      if (this.editedIndex > -1) {
        let data = {
          id: this.editedItem.id,
          title: this.editedItem.title,
          gender: this.editedItem.gender,
          firstname: this.editedItem.firstname,
          lastname: this.editedItem.lastname,
          middlename: this.editedItem.middlename,
          department_id: this.editedItem.dept_id,
          unit_id: this.editedItem.unit_id,
          employee_no: this.editedItem.employee_no,
          dob: moment(String(this.dob)).format("l"),
          dateofemployement: moment(String(this.date_emp)).format("l"),
          insurance_no: this.editedItem.insurance_no,
          insurance_iss_date: moment(String(this.in_iss_date)).format("l"),
          service_status: this.editedItem.service_status,
          image: this.base64img ? this.base64img : null
        };
        this.submit("edit", data);
        //console.log("editing");
        // console.log(this.editedItem);
      } else {
        let data = {
          title: this.editedItem.title,
          gender: this.editedItem.gender,
          firstname: this.editedItem.firstname,
          lastname: this.editedItem.lastname,
          middlename: this.editedItem.middlename,
          department_id: this.editedItem.dept_id,
          unit_id: this.editedItem.unit_id,
          employee_no: this.editedItem.employee_no,
          dob: moment(String(this.dob)).format("l"),
          dateofemployement: moment(String(this.date_emp)).format("l"),
          insurance_no: this.editedItem.insurance_no,
          insurance_iss_date: moment(String(this.in_iss_date)).format("l"),
          service_status: this.editedItem.service_status,
          image: this.base64img ? this.base64img : null
        };
        //console.log("add new");
        //console.log(this.editedItem);
        this.submit("add", data);
      }
      this.close();
    }
  }
};
</script>

<style scoped></style>
